import { Constants } from "@/constants/enums";

export const JWT = "token";
export const APP_SET_MENU = "false";
export const APP_SET_NAVBAR = "true";
export const APP_SET_LOGIN = "true";
export const SHOW_SNACK = 'showSnack'
export const SHOW_SNACK_ERROR = 'showSnackError'
export const SHOW_SNACK_INFO = 'showSnackInfo'
export const HIDE_SNACK = 'hideSnack'
export const SET_CHAT_UNREAD = 'setChatUnread'
export const OPEN_CHAT_PANEL = 'openChatPanel'
export const CLOSE_CHAT_PANEL = 'closeChatPanel'
export const SET_CHAT_PANEL_CONVERSATION = 'setChatPanelConversation'
export const SET_CHAT_VIEWING = 'setChatViewing'

export const SESSION_SEVERAL_DATA = null;
export const SESSION_USER_ACCESS_GROUP = null;
export const SESSION_USER_DATA = null;
export const SESSION_USER_ADDRESS = null;
export const SESSION_BUSINESS_UNIT = null;
export const SESSION_PENDING_JOIN_REQUEST = null;
export const SESSION_PERSON_TYPE = Constants.Enums.PERSONTYPE.NO_USER;
export const SESSION_PROFILE_TYPE = Constants.Enums.PROFILE_TYPE.UNDEFINED;